import { useState } from "react";
import BottomSheet from "shared/components/common/BottomSheet";

type BottomSheetButtonProps = {
  className: string;
  label: string;
  children: React.ReactNode;
  id: string;
};

const BottomSheetButton = ({
  className,
  label,
  children,
  id,
}: BottomSheetButtonProps) => {
  const [showPopUp, setShowPopUp] = useState(false);
  const handleClick = () => {
    setShowPopUp((prev) => !prev);
  };

  return (
    <>
      <button
        id={id}
        type="button"
        className={`control-button ${className}`}
        onClick={handleClick}
      >
        {label}
      </button>
      <BottomSheet
        title={label}
        isOpen={showPopUp}
        onClose={() => setShowPopUp(false)}
      >
        {children}
      </BottomSheet>
    </>
  );
};

export default BottomSheetButton;
